import React, { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface Props {
  onClick?: () => void
  className?: string
  children: ReactNode
}
export const ButtonIcon = React.forwardRef<HTMLButtonElement, Props>(
  ({ onClick, className, children }, ref) => {
    return (
      <Button
        className={className}
        onClick={onClick}
        ref={ref}
        size={'icon'}
        variant={'default'}
      >
        {children}
      </Button>
    )
  }
)

// Set display name for better debugging and lint compliance
ButtonIcon.displayName = 'ButtonIcon'
